import createMultiTabState from 'vuex-multi-tab-state'
localStorage.removeItem('vuex-multi-tab')
export default ({ store }) => {
  createMultiTabState({
    statesPaths: ['cart', 'checkout', 'customer', 'i18n.locale'],
  })(store)
}
